<template>
  <div v-if="show" class="list-box">
    <div class="componentclose" @click="show = false">X</div>
    <div class="serch-box">
      <h1 style="margin:0">{{ companyName }}（{{ companyData.year }}）</h1>
      <ul>
        <li>
          <span style="width:80px">姓名：</span>
          <el-input v-model="search.姓名" size="mini" @keyup.enter.native="toserch"></el-input>
        </li>
        <li>
          <span style="width:80px">职能模块：</span>
          <el-select v-model="search.职能模块" filterable multiple size="mini">
            <el-option v-for="item in categories" :key="item.名称" :value="item.名称"></el-option>
          </el-select>
        </li>
        <li>
          <span style="width:80px">部门：</span>
          <el-autocomplete v-model="search.部门" size="mini" :fetch-suggestions="querySearchDepartment">
          </el-autocomplete>
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="toserch">
            搜索
          </div>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 10px;" @click="clearSerch">
            清空
          </div>
        </li>
        <li>
          <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 40px;" @click="showBulletin">
            情报
          </div>
        </li>
        <li>
          <el-popover placement="right" width="700" trigger="click">
            <div class="radish-btn radish-btn-primary radish-btn-small" @click="uploadParsedXslx">补充已解析表格</div>
            <FileTable
              :files="parsedXslx"
              :paginate="false"
              width="600"
              :show-download="isAdmin"
              height="300"
              :on-delete="deleteFormerYearListFile"
            />
            <div
              slot="reference"
              class="radish-btn radish-btn-primary radish-btn-small uploadParsedXslx"
              style="margin-left: 40px;"
            >
              已上传表格
            </div>
          </el-popover>
        </li>
      </ul>
      <div class="radish-act-grp">
        批量：
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="showEditDialog">修改字段内容</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="showCateDialog('添加')">添加职能模块</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="showCateDialog('删除')">删除职能模块</div>
      </div>
      <div class="radish-btn radish-btn-primary radish-btn-small" style="margin-left: 40px;" @click="mulComplete">
        批量补全信息（部门、目前职位）
      </div>
      <div
        v-if="isAdmin"
        class="radish-btn radish-btn-primary radish-btn-small"
        style="margin-left: 40px;"
        @click="deleteTheTable"
      >
        删除表格
      </div>
      <div
        v-if="isAdmin || isShuju"
        class="radish-btn radish-btn-primary radish-btn-small"
        style="margin-left: 40px;"
        @click="uploadExcel"
      >
        上传Excel补全数据
      </div>
      <span class="radish-btn radish-btn-primary radish-btn-small" @click="showHeadOrderDialog"> 表头调整 </span>
    </div>
    <div v-loading="loading" class="table-box">
      <el-table
        v-if="!loading"
        ref="multipleTable"
        :data="tableData"
        border
        :height="listheight"
        tooltip-eff0-ect="dark"
        size="mini"
        style="width: 100%"
        highlight-current-row
        :span-method="computedSameDepartment"
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <div v-if="scope.row.rid && editRowIndex !== scope.$index">
              <span class="drawer-link" @click="edit(scope.$index)">编辑</span>
              <el-dropdown>
                <i class="el-icon-setting"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="completeDepartment(scope.row)">补全部门信息</el-dropdown-item>
                  <el-dropdown-item @click.native="coverDepartment(scope.row)">覆盖部门信息</el-dropdown-item>
                  <el-dropdown-item @click.native="unBind(scope.row, scope.$index)">解除绑定</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-else-if="scope.row.rid && editRowIndex === scope.$index">
              <span class="drawer-link" style="margin-right:5px" @click="cancelEdit">取消</span>
              <span class="drawer-link" @click="confirmEdit">保存</span>
            </div>
            <div v-else>
              <el-dropdown v-if="isAdmin">
                <i class="el-icon-setting"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="deleteThisRow(scope.row, scope.$index)">删除本行</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
        <template v-for="item in tableHeads">
          <el-table-column
            v-if="!item.hidden"
            :key="item.label"
            :prop="item.key"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="editRowIndex !== scope.$index">
                <div v-if="item.key === '姓名'" class="name-cell">
                  <span class="simi-icon" size="mini" @click="getSimi(scope.row)">
                    <i :class="simiClass(scope.row)"></i>
                  </span>
                  <span v-if="scope.row.rid" class="drawer-link" @click="showRadishDetail(scope.row)">{{
                    scope.row['姓名']
                  }}</span>
                  <span v-else class="company-pointer" @click="showBindRadish(scope.row, scope.$index)">{{
                    scope.row['姓名']
                  }}</span>
                  <span v-if="scope.row.rid && !scope.row.手机" style="line-height: 14px;" class="cc-icon">c</span>
                </div>
                <div v-else-if="tagKeys.includes(item.key)">
                  <el-tag
                    v-for="(tag, index) in getTags(scope.row[item.key])"
                    :key="index + 2"
                    type="success"
                    size="mini"
                    style="text-align:center"
                  >
                    {{ tag }}
                  </el-tag>
                </div>
                <div v-else-if="btnKeys.includes(item.key)">
                  <span
                    v-if="item.key === '部门详情' && scope.row.部门"
                    class="drawer-link"
                    @click="showDepartmentDetail(scope.row)"
                    >部门详情</span
                  >
                  <span
                    v-if="item.key === '口碑打分' && scope.row.rid"
                    class="drawer-link"
                    @click="showScore(scope.row)"
                    >口碑打分</span
                  >
                  <span
                    v-if="item.key === '任职经历' && scope.row.rid"
                    :id="`任职经历${scope.row.rid}`"
                    class="drawer-link"
                    @click="showExp(scope.row)"
                    >查看（{{ getExpNum(scope.row) }}）</span
                  >
                </div>
                <div v-else-if="item.key === '手机'">
                  <el-tooltip class="item" effect="dark" :content="scope.row[item.key]" placement="top">
                    <span v-if="scope.row[item.key]" class="company-pointer">***</span>
                  </el-tooltip>
                </div>
                <div v-else>
                  <span class="company-pointer" @click="clickCol(scope.row, item.key)">{{ scope.row[item.key] }}</span>
                  <!-- TODO:测试服解除注释 -->
                  <!-- <el-tooltip v-if="item.key==='当前部门'&&scope.row.当前部门" class="item" effect="dark" content="修改该公司中此部门的名称" placement="top">
                  <i class="el-icon-edit" @click="toUpdateDepartmentName(scope.row,item.key)"></i>
                </el-tooltip> -->
                </div>
              </div>
              <div v-else>
                <!-- 编辑样式 -->
                <div v-if="inputKeys.includes(item.key)">
                  <el-input v-model="editObj[item.key]" size="mini"></el-input>
                </div>
                <div v-else-if="cannotEditKeys.includes(item.key)">
                  <span>{{ scope.row[item.key] }}</span>
                </div>
                <div v-else-if="btnKeys.includes(item.key)">
                  <span
                    v-if="item.key === '口碑打分' && scope.row.rid"
                    class="drawer-link"
                    @click="showScore(scope.row)"
                    >口碑打分</span
                  >
                  <span
                    v-if="item.key === '任职经历' && scope.row.rid"
                    :id="`任职经历${scope.row.rid}`"
                    class="drawer-link"
                    @click="showExp(scope.row)"
                    >查看（{{ getExpNum(scope.row) }}）</span
                  >
                </div>
                <div v-else>
                  <el-select
                    v-if="objOptions.includes(item.key)"
                    v-model="editObj[item.key]"
                    :multiple="tagKeys.includes(item.key)"
                    filterable
                    size="mini"
                  >
                    <el-option v-for="(v, k) in selectOption[item.key]" :key="v" :label="k" :value="v"> </el-option>
                  </el-select>
                  <el-select
                    v-else
                    v-model="editObj[item.key]"
                    :multiple="tagKeys.includes(item.key)"
                    filterable
                    size="mini"
                    @change="val => setSelectOption(val, item.key)"
                  >
                    <el-option v-for="item in selectOption[item.key]" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination
        class="company-pagination"
        :current-page="page"
        :page-sizes="[20, 70, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <!-- 搜索人选弹窗 -->
    <serch-radish-dialog
      ref="serchRadishDialog"
      :could-insert="true"
      :sort="companyName"
      choose-btn-text="绑定"
      @choose="bindRadish"
    >
    </serch-radish-dialog>
    <!-- 任职经历漂浮窗 -->
    <RadishExperiencePopper ref="RadishExperiencePopper"></RadishExperiencePopper>
    <UploadDialog ref="UploadDialog" type="附件" label="list" :on-success="uploadsuccess" :on-error="uploaderror" />
    <!-- 当前部门备注dialog -->
    <el-dialog
      title="部门备注"
      :visible.sync="currentDepartmentVisible"
      :close-on-click-modal="false"
      :modal="false"
      width="30%"
    >
      <el-input v-model="departmentRemark" type="textarea" :rows="2" resize="none" placeholder="请输入内容"> </el-input>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="currentDepartmentVisible = false">
          取 消
        </div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="updateCurrentDepartment">确 定</div>
      </span>
    </el-dialog>
    <!-- 修改部门名称dialog -->
    <el-dialog
      title="部门名称"
      :visible.sync="departmentNameVisible"
      :close-on-click-modal="false"
      :modal="false"
      width="30%"
    >
      <el-input v-model="newDepartment.newname" resize="none" placeholder="请输入内容" @blur="checkDepartmentName">
      </el-input>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="checkDepartmentName">检查</div>
      <!-- <el-button size="mini" @click="checkDepartmentName">检查</el-button> -->
      <span v-if="alertDepartmentName">{{ alertDepartmentName }}</span>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="departmentNameVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirmUpdate">确 定</div>
        <!-- <el-button size="mini" @click="departmentNameVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmUpdate">确 定</el-button> -->
      </span>
    </el-dialog>
    <!-- 情报 -->
    <Bulletin ref="Bulletin" :company-name="companyName"></Bulletin>
    <!-- <MulEditDialog ref="mulEditDialog"
                   @confirm="mulUpdateConfirm"></MulEditDialog> -->
    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
    <headOrderDialog ref="headOrderDialog"></headOrderDialog>
  </div>
</template>
<script>
import { FileTable } from '../../file'
import serchRadishDialog from '../../company/src/component/serchRadishDialog.vue'
import { Bulletin, RadishExperiencePopper } from '../../company'
import tableHeads from '../../radish/src/constant/table-heads'
import editDialog from '../../radish/src/dialog/edit-dialog'
import cateDialog from '../../radish/src/dialog/cate-dialog'
import headOrderDialog from '../../radish/src/dialog/head-order-dialog'

const { fieldsBasic } = require('../../radish/src/constant/fields-detail.js')

export default {
  components: {
    FileTable,
    serchRadishDialog,
    Bulletin,
    RadishExperiencePopper,
    editDialog,
    cateDialog,
    headOrderDialog,
  },
  data() {
    return {
      tableData: [],
      companyName: '',
      show: false,
      loading: false,
      dialogBindRadish: false,
      bindRadishKeywords: '',
      departmentRemark: '',
      editRowIndex: -1,
      tableHeads: [
        { label: '部门（当前list）', key: '部门', width: '240' },
        { label: '二级部门（当前list）', key: '二级部门', width: '135' },
        { label: '目前职位（当前list）', key: '目前职位', width: '135' },
        { label: '当前公司', key: '当前公司', width: '135' },
        { label: '姓名', key: '姓名', width: '100' },
        { label: '部门（系统）', key: '当前部门', width: '100' },
        { label: '部门详情', key: '部门详情', width: '100' },
        { label: '组别', key: '组别', width: '100' },
        { label: '目前职位（系统）', key: '当前目前职位', width: '160' },
        { label: '职能模块', key: '职能模块', width: '140' },
        { label: '地域', key: '地域', width: '100' },
        { label: '口碑打分', key: '口碑打分', width: '100' },
        { label: '任职经历', key: '任职经历', width: '140' },
        { label: '细分职能', key: '细分职能', width: '100' },
        { label: '擅长方向', key: '擅长方向', width: '100' },
        { label: '职级', key: '职级', width: '100' },
        { label: '业绩', key: '业绩', width: '100' },
        { label: '长期意向', key: '长期意向', width: '100' },
        { label: '手机', key: '手机', width: '100' },
      ],
      selectOption: {
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        地域: fieldsBasic.地域.options,
        职级: fieldsBasic.职级.options,
        业绩: fieldsBasic.业绩.options,
        长期意向: ['Y', 'N', 'F'],
      },
      inputKeys: ['姓名', '手机', '当前部门', '组别', '当前目前职位'],
      cannotEditKeys: ['部门', '二级部门', '目前职位'],
      objOptions: ['职级', '长期意向'],
      tagKeys: ['职能模块', '细分职能', '擅长方向', '地域'],
      btnKeys: ['口碑打分', '任职经历', '部门详情'],
      query: {},
      search: {
        姓名: '',
        职能模块: [],
        部门: '',
      },
      status: [
        { value: '在职', class: 'el-icon-success icon-blue' },
        { value: '新入职', class: 'el-icon-warning icon-red' },
        { value: '离职', class: 'el-icon-error icon-grey' },
      ],
      handleDepartmentRadish: '',
      handleRowIndex: -1,
      listheight: '100px',
      page: 1,
      total: 0,
      pageSize: 100,
      editRowIndex: -1,
      editObj: {},
      handleRow: {},
      companyData: { cid: '', year: '' },
      mergeRow: {},
      selectDepartmentOptions: [],
      multipleSelection: [],
      dialogVisible: false,
      department: {},
      isAdmin: false,
      isShuju: false,
      parsedXslx: [],
      uploadType: '',
      canSeeTel: [],
      checkedDepartmentName: false,
      departmentNameVisible: false,
      newDepartment: { 公司: '', oldname: '', newname: '' },
      alertDepartmentName: '',
      updateDepartmentType: 'update',
      currentDepartmentVisible: false,
      clickDepartment: '',
      editDialogTableHeads: [],
      storageName: 'formerYearList',
    }
  },
  computed: {
    categories() {
      return app.categories
    },
  },
  watch: {
    $route(to, from) {
      this.close()
    },
  },
  created() {
    if (app.user && app.user.角色 && app.user.角色.includes('管理员')) this.isAdmin = true
    if (app.user && app.user.角色 && app.user.角色.includes('数据处理')) this.isShuju = true
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    this.selectOption.职能模块 = app.categories.map(catrgory => catrgory.名称)
    const str = app.user.SL权限 || ''
    this.canSeeTel = str.split(';')

    const editTypes = ['细分职能', '擅长方向', '地域', '职级', '业绩', '长期意向', '部门', '组别', '目前职位']
    this.editDialogTableHeads = tableHeads.data().tableHeads.filter(v => editTypes.includes(v.label))
  },
  methods: {
    querySearchDepartment(queryString, cb) {
      const restaurants = this.selectDepartmentOptions
      const results = queryString ? restaurants.filter(val => val && val.includes(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results.map(val => ({ value: val })))
    },
    async unBind(row, index) {
      const result = await window.app.service('company').unBindFormerYearRadish(row)
      if (result.status === 'success') {
        this.tableData.splice(index, 1, result.data)
      } else {
        this.$message.error(result.msg)
      }
    },
    async confirmUpdate() {
      if (!this.alertDepartmentName) {
        return
      }
      if (this.newDepartment.oldname === this.newDepartment.newname) {
        this.$message('名称一样，未做修改')
        return
      }
      this.departmentNameVisible = false
      let res
      if (this.updateDepartmentType === 'merge') {
        res = await window.app.service('company').mergeDepartment({
          olddata: { 公司: this.newDepartment.公司, label: this.newDepartment.oldname },
          newdata: { 公司: this.newDepartment.公司, label: this.newDepartment.newname },
        })
      } else {
        res = await window.app.service('company').updateDepartmentName({
          公司: this.newDepartment.公司,
          oldname: this.newDepartment.oldname,
          newname: this.newDepartment.newname,
        })
      }
      if (res.status === 200) {
        this.$message('修改成功')
        this.loadData()
      } else {
        this.$message(res.msg)
      }
    },
    // toUpdateDepartmentName(row, key) {
    //   this.departmentNameVisible = true
    //   this.alertDepartmentName = ''
    //   console.log(row)
    //   this.checkedDepartmentName = false
    //   this.newDepartment.公司 = this.companyName
    //   this.newDepartment.oldname = row.当前部门
    //   this.newDepartment.newname = row.当前部门
    // },
    async checkDepartmentName(row) {
      const option = { 公司: this.newDepartment.公司, 部门: this.newDepartment.newname }
      console.log(option)
      const res = await app.service('company').checkDepartmentName(option)
      if (res.status === 'success') {
        this.alertDepartmentName =
          res.msg === '已存在' ? '该名称已存在,点击确定将把两个部门进行合并' : '该名称可以使用点击确定进行修改'
        this.updateDepartmentType = res.msg === '已存在' ? 'merge' : 'update'
        this.checkedDepartmentName = true
      } else {
        this.$message.error(res.msg)
      }
    },
    isShowTel(category) {
      if (this.isAdmin) {
        return true
      } else {
        let flag = false
        if (Array.isArray(category)) {
          category.forEach(val => {
            if (this.canSeeTel.includes(val)) flag = true
          })
        } else {
          flag = true
        }
        return flag
      }
    },
    async showDepartmentDetail(row) {
      const result = await window.app.service('company').getDepartmentDetail({
        公司: this.companyName,
        部门: row.当前部门,
      })
      this.currentDepartmentVisible = true
      this.departmentRemark = result.data.部门备注 || ''
      this.handleDepartmentRadish = row
    },
    async updateCurrentDepartment() {
      const row = this.handleDepartmentRadish
      const result = await window.app.service('company').updateDepartmentDetail({
        query: { 公司: this.companyName, 部门: row.当前部门 },
        data: { 部门备注: this.departmentRemark },
      })
      if (result.status == 200) {
        this.$message('保存成功')
        this.currentDepartmentVisible = false
      }
    },
    async uploadParsedXslx() {
      this.uploadType = 'parsedXslx'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
      const dom = document.querySelector('.uploadParsedXslx')
      if (dom) dom.click()
    },
    async deleteThisRow(row, index) {
      const res = await app.service('company').deleteFormerYearsRow(row._id)
      if (res.status === 'success') {
        this.$message('删除成功')
        this.tableData.splice(index, 1)
      } else this.$message(res.msg)
    },
    initHeight() {
      this.$nextTick(() => {
        const serchDom = this.$el.querySelector('.serch-box')
        const serchHeight = (serchDom && serchDom.offsetHeight) || 120
        this.listheight = `${window.innerHeight - (serchHeight + 60 + 32 + 6)}px`
      })
    },
    mulComplete() {
      const arr = this.multipleSelection.filter(v => v.rid)
      if (arr.length === 0) this.$message('请选择有效行，仅可修改已绑定人选的数据')
      else arr.forEach(row => this.completeDepartment(row))
    },
    mulCover() {
      const arr = this.multipleSelection.filter(v => v.rid)
      if (arr.length === 0) this.$message('请选择有效行，仅可修改已绑定人选的数据')
      else arr.forEach(row => this.coverDepartment(row))
    },
    async completeDepartment(row) {
      const res = await app.service('company').completeRadishDepartment(row)
      if (res.status === 'success') this.$message('修改成功')
      else this.$message(res.msg)
    },
    async coverDepartment(row) {
      const res = await app.service('company').coverRadishDepartment(row)
      if (res.status === 'success') this.$message('修改成功')
      else this.$message(res.msg)
    },
    clickCol(row, key) {
      if (key === '部门') {
        const status = this.clickDepartment !== row.部门
        this.clickDepartment = status ? row.部门 : ''
        this.tableData.forEach(val => {
          if (val.部门 === row.部门) this.$refs.multipleTable.toggleRowSelection(val, status)
        })
      }
    },
    getTags(val) {
      if (typeof val === 'string' && val) return [val]
      else if (Array.isArray(val)) return val.filter(v => v)
      else return []
    },
    async getFormerYearDepartments() {
      const res = await app.service('company').getFormerYearDepartments(this.companyData)
      if (res.status === 'success') this.selectDepartmentOptions = res.data
    },
    async getFormerYearListFile() {
      const res = await window.app.service('company').getFormerYearListFile(this.companyData)
      if (res.status === 'success') {
        this.parsedXslx = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async deleteFormerYearListFile(row) {
      const res = await window.app.service('company').deleteFormerYearListFile(row)
      if (res.status === 'success') {
        this.parsedXslx = this.parsedXslx.filter(v => v._id !== row._id)
        this.$message('删除成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    uploadExcel() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async insertFormerYearListFile(response) {
      const option = Object.assign({}, response, this.companyData)
      const res = await window.app.service('company').insertFormerYearListFile(option)
      if (res.status === 'success') {
        this.$message('上传成功')
        this.getFormerYearListFile()
      } else {
        this.$message.error(res.msg)
      }
    },
    async uploadsuccess(responce, file, filelist) {
      if (this.uploadType === 'parsedXslx') {
        this.insertFormerYearListFile(responce[0])
        this.uploadType = ''
      } else {
        const result = await window.app.service('file').parseXlsx(responce[0])
        const option = Object.assign({ table: result.sheetsData, fileId: responce[0].md5 }, this.companyData)
        const res = await app.service('company').insertFormerYearsList(option)
        this.$message(res.msg)
        this.insertFormerYearListFile(responce[0])
        // const { cid, year } = this.companyData
        // this.loadData()
      }
    },
    async uploaderror(responce) {
      this.$message.error(responce)
    },
    async deleteTheTable() {
      this.$confirm('此操作将永久删除该表格, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('company').deleteFormerYearsList(this.companyData)
          if (res.status === 'success') {
            this.$message('删除成功')
            this.tableData = []
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    computedSameDepartment({ row, column, rowIndex, columnIndex }) {
      if (column.label === '部门（当前list）') {
        if (this.mergeRow[rowIndex]) return this.mergeRow[rowIndex]
        else return { rowspan: 0, colspan: 0 }
      }
    },
    computedSame() {
      const obj = {}
      const department = []
      let lastDepartment = { 部门: '', startIndex: '', endIndex: '' }

      for (let index = 0, len = this.tableData.length; index < len; index++) {
        const row = this.tableData[index]
        if (index === 0) {
          if (len === 1) {
            obj[0] = { rowspan: 1, colspan: 1 }
          } else {
            lastDepartment = { 部门: row.部门, startIndex: 0, endIndex: 0 }
            continue
          }
        }

        if (index === len - 1) {
          if (row.部门 == lastDepartment.部门) {
            lastDepartment.endIndex = index
          } else {
            obj[index] = { rowspan: 1, colspan: 1 }
          }
          const cha = lastDepartment.endIndex - lastDepartment.startIndex
          obj[lastDepartment.startIndex] = { rowspan: cha + 1, colspan: 1 }
          continue
        }

        if (row.部门 == lastDepartment.部门) {
          lastDepartment.endIndex = index
        } else {
          const cha = lastDepartment.endIndex - lastDepartment.startIndex
          obj[lastDepartment.startIndex] = { rowspan: cha + 1, colspan: 1 }
          lastDepartment = { 部门: row.部门, startIndex: index, endIndex: index }
        }
      }

      this.mergeRow = obj
      console.log(this.mergeRow)
    },
    open(data) {
      this.companyData = data
      this.companyName = data.companyName
      this.show = true
      this.initHeight()
      this.getFormerYearDepartments()
      this.clearSerch()
    },
    showBulletin() {
      this.$refs.Bulletin.open()
    },
    setSelectOption(arr, key) {
      if (key !== '职能模块') return
      let directionArr = []
      arr.forEach(val => {
        const o = app.categories.find(v => v.名称 === val)
        if (o) directionArr = directionArr.concat(o.擅长方向)
      })
      this.selectOption.擅长方向 = directionArr
      let secondArr = []
      arr.forEach(val => {
        const o = app.categories.find(v => v.名称 === val)
        if (o) secondArr = secondArr.concat(o.二级职能)
      })
      this.selectOption.细分职能 = secondArr
    },
    edit(index) {
      this.editRowIndex = index
      const row = this.tableData[index]
      for (const key in row) {
        const val = typeof row[key] === 'object' ? JSON.parse(JSON.stringify(row[key])) : row[key]
        this.$set(this.editObj, key, val)
      }
      this.setSelectOption(this.editObj.职能模块, '职能模块')
    },
    cancelEdit() {
      this.editRowIndex = -1
      this.editObj = {}
    },
    async confirmEdit() {
      const keys = ['姓名', '职能模块', '细分职能', '组别', '擅长方向', '地域', '职级', '业绩', '长期意向', '手机']
      const option = {}
      const oldData = this.tableData[this.editRowIndex]
      const newData = this.editObj
      keys.forEach(key => {
        if (typeof newData[key] === 'object') {
          if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
            option[key] = newData[key]
          }
        } else if (newData[key] !== oldData[key]) option[key] = newData[key]
      })
      if (newData['当前部门'] !== oldData['当前部门']) option['部门'] = newData['当前部门']
      if (newData['当前目前职位'] !== oldData['当前目前职位']) option['目前职位'] = newData['当前目前职位']
      if (Object.keys(option).length > 0) {
        const res = await app.service('radish').modifyById({
          _id: oldData.rid,
          data: option,
        })
        if (res.status == 'success') {
          Object.keys(option).forEach(key => {
            if (key === '部门') oldData['当前部门'] = newData['当前部门']
            else if (key === '目前职位') oldData['当前目前职位'] = newData['当前目前职位']
            else oldData[key] = newData[key]
          })
          this.$message.success({ duration: 500, message: '修改成功' })
        } else this.$message.error(res.msg)
      }
      this.cancelEdit()
    },
    getExpNum(item) {
      const exp = item.任职经历
      return Array.isArray(exp) ? exp.length : '0'
    },
    async showExp(item) {
      const option = { radishId: item.rid, 任职经历: item.任职经历, 姓名: item.姓名 }
      this.$refs.RadishExperiencePopper.open(option)
    },
    showScore(row) {
      app.root.$refs.radishScore.open(row.rid)
    },
    simiClass(row) {
      if (row.status == 1) return 'el-icon-question icon-lightred'
      else if (row.status == 2) return 'el-icon-success icon-blue'
      else if (row.status == 3) return 'el-icon-warning icon-red'
      else if (row.status == 4) return 'el-icon-error icon-grey'
      else return ''
    },
    async getSimi(item) {
      if (!item.rid) {
        this.$message('该数据未与人选绑定')
        return
      }
      const copyObj = JSON.parse(JSON.stringify(item))
      copyObj._id = copyObj.rid
      copyObj.thirdId = copyObj.个人ID
      delete copyObj.rid
      delete copyObj.个人ID
      if (copyObj.status && copyObj.status > 0) {
        app.root.$refs.simiDialog.show(copyObj)
      }
    },
    showRadishDetail(opts) {
      console.log(opts, { id: opts.rid, title: opts.姓名 })
      if (opts.rid) {
        window.open(`${window.frontend}/#/radish-detail-blank/${opts.rid}`, '_blank')
      } else this.$message('未与人选绑定')
    },
    async showBindRadish(row, index) {
      const defaultSerchRadishes = await this.getDefaultSerchData(row)
      this.$refs.serchRadishDialog.open(row, defaultSerchRadishes)
      this.handleRowIndex = index
      this.handleRow = row
    },
    async getDefaultSerchData(radish) {
      const res = await app.service('company').defaultSerchRadishes(radish.姓名)
      if (res.status === 'success') return res.data
      else return []
    },
    async bindRadish(radish) {
      const copyRadish = JSON.parse(JSON.stringify(radish))
      const row = this.tableData[this.handleRowIndex]
      row.rid = copyRadish._id
      delete copyRadish._id
      for (const key in copyRadish) {
        if (key === '部门') row['当前部门'] = copyRadish[key]
        else if (key === '目前职位') row['当前目前职位'] = copyRadish[key]
        else row[key] = copyRadish[key]
      }
      // 该人选绑定协会数据
      const res = await app.service('company').formerYearBindRadish({ _id: row._id, rid: radish._id })
      if (res.status !== 'success') {
        this.$message(res.msg)
      } else {
        this.tableData.splice(this.handleRowIndex, 1, row)
      }
    },
    async updatecompany(id, type) {
      const result = await window.app
        .service('company')
        .updateCompany({ company: { _id: id, 公司性质: type }, accessory: [] })
      if (result.status !== 200) {
        this.$message('修改失败，请稍后再试')
      }
    },
    sortChange(data) {
      if (data.prop === '排名' || data.prop === '签约时间') {
        this.sort[data.prop] = data.order === 'descending' ? -1 : 1
      }
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    trim(val) {
      return val.replace(/(^\s*)|(\s*$)/g, '')
    },
    toserch() {
      this.page = 1
      const option = {}
      for (const key in this.search) {
        const val = this.search[key]
        if (typeof val === 'string') {
          if (val !== '') option[key] = this.trim(val)
        } else option[key] = val
      }
      this.query = option
      this.loadData()
    },
    clearSerch() {
      for (const key in this.search) {
        if (Array.isArray(this.search[key])) this.search[key] = []
        else this.search[key] = ''
      }
      this.query = {}
      this.page = 1
      this.loadData()
    },
    async loadData() {
      const query = Object.assign({ query: this.query }, this.companyData, {
        paginate: {
          page: this.page,
          pageSize: this.pageSize,
        },
      })
      try {
        this.loading = true
        const { data, page, pageSize, total } = await app.service('company').getFormerYearsList(query)
        this.setHiddenCell()
        this.setCellOrder()
        this.loading = false
        this.tableData = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
        this.computedSame()
        this.getFormerYearListFile()
      } catch (error) {
        this.$message(error.message)
      }
    },
    close() {
      this.show = false
    },
    showEditDialog() {
      if (this.multipleSelection.length === 0) return this.$message('请勾选人员')
      const arr = this.multipleSelection.filter(v => v.rid)
      const rows = arr.map(v => {
        const copyObj = JSON.parse(JSON.stringify(v))
        copyObj._id = v.rid
        copyObj.公司 = this.companyName
        delete copyObj.rid
        return copyObj
      })
      this.$refs.editDialog.show(this.editDialogTableHeads, rows)
    },
    showCateDialog(type) {
      if (this.multipleSelection.length === 0) return this.$message('请勾选人员')
      const arr = this.multipleSelection.filter(v => v.rid)
      const ids = arr.map(v => v.rid)

      if (ids.length === 0) return this.$message('请勾选已绑定人选')
      this.$refs.cateDialog.show(type, app.categories, ids)
    },
    showHeadOrderDialog() {
      const heads = this.tableHeads.map(head => ({ label: head.label, visible: !head.hidden }))

      this.$refs.headOrderDialog.show({
        heads,
        storageName: this.storageName,
        onConfirm: () => {
          this.loadData()
        },
      })
    },
    setHiddenCell: function() {
      const heads = localStorage[this.storageName]
      if (heads) {
        const cells = JSON.parse(heads)
        const tmp = this.tableHeads.map(h => {
          if (cells[h.label]) {
            h.hidden = cells[h.label]
          } else {
            h.hidden = false
          }
          return h
        })
        this.tableHeads = tmp
      }
    },
    setCellOrder: function() {
      const headSort = localStorage[`${this.storageName}_sort`]
      if (headSort) {
        const cellSort = JSON.parse(headSort)
        const tmp = this.tableHeads.sort((a, b) => {
          const labelA = a.label
          const labelB = b.label
          if (!cellSort[labelA] || cellSort[labelA] > cellSort[labelB]) {
            return 1
          } else {
            return -1
          }
          // if (cellSort[labelA] > cellSort[labelB]) {
          //   return 1
          // } else {
          //   return -1
          // }
        })
        this.tableHeads = tmp
      }
    },
  },
}
</script>
<style scoped>
ul {
  padding: 0;
  overflow: hidden;
  list-style: none;
}
.serch-box {
  padding: 10px 20px 10px 20px;
  margin: 0 0 5px;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.serch-box span {
  display: inline-block;
}

.serch-box li {
  max-width: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  margin: 5px;
}

.company-pointer {
  cursor: pointer;
}
.name-cell {
  position: relative;
  padding-left: 12px;
}
.list-box {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 30;
  padding-bottom: 10px;
  width: 100vw;
  background-color: #fff;
}
.componentclose {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #e83939;
  border-radius: 50%;
}
</style>
